<script setup lang="ts">
const colorMode = useColorMode()
const isDark = computed({
  get () {
    return colorMode.value === 'dark'
  },
  set () {
    colorMode.preference = colorMode.value === 'dark' ? 'light' : 'dark'
  }
})
</script>

<template>
  <client-only>
    <img
      v-bind="$attrs"
      :src="isDark ? '/logo_light.png' : '/logo_normal.png'"
      alt="Logo"
      class="py-3"
      crossorigin="anonymous"
    >
  </client-only>
</template>
